import 'submodules/responsiveruptly/src/less/live.less';
import 'submodules/responsiveruptly/src/less/plan-details.less';
import 'submodules/responsiveruptly/src/less/plan.less';
import AcceptAgreementsModals from 'components/accept-agreements-modals';
import Component from 'components/component';
import HeaderView from 'components/header/view';
import HelmetWrap from 'components/helmet-wrap';
import PageLoading from 'components/page-loading';
import * as routes from 'config/routes';
import { cyrillicTitle, prepareUrl } from 'helpers/strings';
import frontload from 'hoc/frontload';
import page from 'hoc/page';
import { DI } from 'modules';
import Preview from 'pages/content/components/preview';
import NotFoundPage from 'pages/content/not-found';
import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import PanelDownload from './download';
import PaymentAlert from './payment-alert';
import Description from './view-description';
import ViewVideoSiblings from 'pages/content/videos/view/view-siblings';
import HotBox from 'components/hot-box/hot-box';
import { sendRequest } from "utils/api";
import { DateTime } from 'luxon';

const customOffset = {
  margin: '0 0 0 30px',
  height: 'auto'
};

class VideoView extends Component {
  state = {
    downloadStarted: false,
    invalid: false,
    relatedVideos: [],
  };

  static preload(props) {
    const slug = VideoView.getSlug(props.match.params.id);

    return Promise.all([
      props.actions.videos.getVideo(slug).then(resp => {
        if (props.user.isSignedIn) {
          return Promise.all([
            props.actions.user.getActiveAgreements({
              content_id: resp.body.inner_id,
              content_type: 'vod',
            }),
            props.actions.user.getAgreements(),

            props.actions.user
              .getVideoLists({
                video_id: resp.body.inner_id,
              })
              .then(() => {
                props.actions.common.wrapClass('profile--mylists');
              }),
          ]);
        } else {
          return resp;
        }
      }),

      props.actions.videos.getRelatedList({
        ...props.common.searchParams,
      }),
    ]);
  }

  static getSlug(idParam) {
    let [slug] = idParam.match(/(\d{8}(-\w+\d+)?)/) || [];
    if (!slug) {
      [slug] = idParam.match(/(\d{4,6})/) || [];
    }
    return slug;
  }

  loadRelatedVideos = async () => {
    const relatedTags = this.video.tags.filter(tag => {
      return tag.state !== 'special' && ![368, 12].includes(tag.id);
    })
    if (relatedTags.length) {
      const dateNow = DateTime.local();
      sendRequest({
        method: 'GET',
        url: '/api/content/video_projects',
        data: {
          page: 1,
          per_page: 30,
          q: {
            tags_id_in: relatedTags.map(({id}) => id),
            id_not_eq: this.video.inner_id,
            translations_published_at_gteq: dateNow.minus({days: 30}).toISO(),
            translations_published_at_lteq: dateNow.toISO(),
          },
          locale: this.props.common.locale,
        }
      }).then(({error, body}) => {
        if (!error && body.videos) {
          this.setState({relatedVideos: body.videos});
        }
      });
    }
  }

  componentDidMount() {
    const { search_key } = this.props.common.searchParams;
    if (search_key) {
      this.setState({ search_key });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const idIsUpdated =
      this.props.match.params.id !== prevProps.match.params.id;
    const userIsUpdated =
      this.props.user.isSignedIn !== prevProps.user.isSignedIn;
    const localeIsUpdated =
      this.props.common.locale !== prevProps.common.locale;

    if (localeIsUpdated || idIsUpdated) {
      this.loadRelatedVideos();
    }

    if (this.video.tags.length && !this._initedRelatedVideos) {
      this._initedRelatedVideos = true;
      this.loadRelatedVideos();
    }

    if (idIsUpdated || userIsUpdated || localeIsUpdated) {
      VideoView.preload(this.props)
        .then(() => {
          this.setState({ invalid: false });
        })
        .catch(error => {
          this.setState({ invalid: true });
          throw error;
        });
    }
  }

  string = key => this.props.common.strings[`page.video.${key}`];

  getImgUrl = size => {
    const img = this.video.selected_preview_image;

    return (img[size] && img[size].url) || img.url;
  };

  onAcceptAgreement = () => {
    this.props.actions.user.getActiveAgreements({
      content_id: this.video.inner_id,
      content_type: 'vod',
    });
  };

  render() {
    const trandingList = this.props.videos.related;
    const strings = this.props.common.strings;
    const video = this.video;
    const {relatedVideos} = this.state;
    const { meta_tag } = video;

    const optionsVideo = {
      entity: video,
      preview: this.getImgUrl('large'),
      watermark: false,
      className: 'j-gc',
    };

    const { downloadStarted, invalid } = this.state;

    if (invalid) {
      return <NotFoundPage/>;
    }

    if (!video.id) {
      if (this.node.pending || !this.node.isInited) {
        return <PageLoading/>;
      } else {
        return <NotFoundPage/>;
      }
    }

    const currentID = this.props.match.params.id;
    const validID = `${video.id}-${cyrillicTitle(this.video.title)}`;
    const canonical = this.props.match.url.replace(currentID, validID);

    return (
      <Fragment>
        <HelmetWrap
          {...(meta_tag || {})}
          video={video}
          page="video"
          canonical={canonical}
        />
        <section className="content">
          <AcceptAgreementsModals
            onAccept={this.onAcceptAgreement}
            acceptOnly
          />
          <div className="wrap">
            <HeaderView
              video={video}
              buttonBackNameOfStr={'page.video.back'}
              defaultBackUrl={routes.videosList.getPath(
                this.props.common.locale,
              )}
              alwaysBackToDefault
              editButton={props => (
                <a
                  href={prepareUrl(
                    `${document.location.hostname}/cms/#/videos/${video.external_name}/edit`,
                  )}
                  target="_blank"
                  style={customOffset}
                  className="text-button"
                >
                  Edit
                </a>
              )}
              viewButton={props => (
                <a
                  href={prepareUrl(
                    `${document.location.hostname}/cms/#/videos/${video.external_name}`,
                  )}
                  target="_blank"
                  style={customOffset}
                  className="text-button"
                >
                  View
                </a>
              )}
            />
            <PaymentAlert
              onClose={() => this._setDownloadStart(false)}
              downloadStarted={downloadStarted}
            />
            <div className="live live--reverse">
              <div className="live-column">
                <Preview {...optionsVideo} />
                <Description entity={video}/>
              </div>
              <div className="live-column">
                <Preview {...optionsVideo} />

                <HotBox
                  clsName={'hot-box--column'}
                  title={strings['page.video.hotbox.title']}
                  text={strings['page.video.hotbox.text']}
                  buttonName={strings['page.video.hotbox.button']}
                />

                <PanelDownload
                  onDownload={() => this._setDownloadStart(true)}
                  entity={video}
                  searchKey={this.state.search_key}
                />

                <ViewVideoSiblings
                  data={relatedVideos.length ? relatedVideos:trandingList.payload}
                  isRelated={Boolean(relatedVideos.length)}
                />
                <Description isMobile entity={video}/>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }

  get node() {
    const slug = VideoView.getSlug(this.props.match.params.id);
    return this.props.videos.byID.getValue(slug);
  }

  get video() {
    return this.node.payload;
  }

  _setDownloadStart(started) {
    this.setState({ downloadStarted: started });
    VideoView.preload(this.props);
  }
}

export default page(
  DI(['common', 'videos', 'user'])(
    frontload(withRouter(VideoView)),
  ),
);
